import { IdeaData } from "types/web-app";

interface IdeaCardProps {
  idea: IdeaData;
  compact?: boolean;
}

export const IdeaCard = ({ idea, compact = false }: IdeaCardProps) => {
  if (compact) {
    return (
      <div className="flex-1 bg-pk-purple-1 rounded-lg p-2 border-2 border-pk-purple-3">
        <div className="flex items-center justify-between">
          <span className="text-pk-gray-4 font-bold text-sm truncate flex-1">
            {idea.title}
          </span>
          <span className="text-pk-purple-4 text-xs ml-2">
            {idea.votes} votes
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md bg-pk-purple-1 rounded-xl p-4 border-3 border-pk-purple-3 shadow-lg">
      <h3 className="text-pk-gray-5 font-bold text-lg mb-2">{idea.title}</h3>
      <p className="text-pk-gray-4 text-sm leading-relaxed whitespace-pre-wrap max-h-[200px] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-pk-gray-3 scrollbar-track-transparent">
        {idea.content}
      </p>
      <div className="flex items-center justify-between mt-4 pt-3 border-t border-pk-purple-2">
        <span className="text-pk-purple-4 text-xs">
          {idea.votes} vote{idea.votes !== 1 ? "s" : ""}
        </span>
        <span className="text-pk-gray-3 text-xs">
          {new Date(idea.created_at).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
};
